import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { toast } from 'sonner';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const GoogleLoginButton = ({ redirectPath = '/dashboard', variant = 'outline', className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    // Check for session_id in URL fragment
    const hash = window.location.hash;
    if (hash && hash.includes('session_id=')) {
      const sessionId = hash.split('session_id=')[1].split('&')[0];
      if (sessionId) {
        processSession(sessionId);
      }
    }
  }, []);

  const processSession = async (sessionId) => {
    setProcessing(true);
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/google/session`, {
        method: 'POST',
        headers: {
          'X-Session-ID': sessionId,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Store session token in localStorage as backup
        localStorage.setItem('session_token', data.session_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        
        // Clean URL
        window.location.hash = '';
        
        toast.success(`Welcome, ${data.user.name}!`);
        
        // Redirect to dashboard
        setTimeout(() => {
          navigate(redirectPath);
        }, 500);
      } else {
        toast.error('Authentication failed');
        setProcessing(false);
      }
    } catch (error) {
      console.error('Session processing error:', error);
      toast.error('Authentication error');
      setProcessing(false);
    }
  };

  const handleGoogleLogin = () => {
    // Construct redirect URL (where user lands after Google auth)
    const baseUrl = window.location.origin;
    const redirectUrl = `${baseUrl}${location.pathname}`;
    
    // Redirect to Emergent Auth
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (processing) {
    return (
      <div className="flex items-center justify-center py-3">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
        <span className="ml-2 text-gray-600">Authenticating...</span>
      </div>
    );
  }

  return (
    <Button
      type="button"
      variant={variant}
      className={`w-full flex items-center justify-center gap-2 ${className}`}
      onClick={handleGoogleLogin}
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />
      </svg>
      Continue with Google
    </Button>
  );
};

export default GoogleLoginButton;
